/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { viagensRoute } from "../data.service";
import { deslocamentosRoute, deslocamentosModuleName } from "../../deslocamentos/shared/data.service";
import { pontosRoute, pontosModuleName } from "../../pontos/shared/data.service";
import { configuracaoModuleName, configuracaoRoute } from "../../../shared/services/data.service";

@Component({
    selector: 'app-viagem-menu',
    template: require('./viagem-menu.component.html')
})
export class ViagemMenuComponent implements OnInit {
    viagensRoute: string = viagensRoute;
    deslocamentosRoute: string = deslocamentosRoute;
    pontosRoute: string = pontosRoute;
    configuracaoRoute: string = configuracaoRoute;

    deslocamentosModule: any = deslocamentosModuleName;
    pontosModule: any = pontosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor() { }

    ngOnInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/shared/viagem-menu/viagem-menu.component.ts
 **/